// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"563":"87f0203a","598":"2cfb08c4","674":"319ca823"}[chunkId] + ".chunk.js";
};